export default __webpack_public_path__ + "static/media/ic_telephone_primary.0fca998d.svg";